export enum StoryInteractionIntent {
  CONNECT_WITH = "connect_with",
  ASK_QUESTION = "ask_question",
}

export enum StoryInteractionStatus {
  NEW = "new",
  IN_PROGRESS = "in_progress",
  SOLVED = "solved",
}

export enum StoryInteractionCtaPlacement {
  PROFILE_CTA_DESKTOP = "profile_cta_desktop",
  PROFILE_CTA_MOBILE = "profile_cta_mobile",
  PROFILE_HERO = "profile_hero",
}

export interface StoryInteractionItem {
  id: string;
  storyToken: string;
  profileId: string;
  profileName: string;
  intent: StoryInteractionIntent;
  ctaPlacement: StoryInteractionCtaPlacement;
  senderFirstName: string;
  senderLastName: string;
  senderEmail: string;
  message: string | null;
  status: StoryInteractionStatus;
  createdAt: string;
  updatedAt: string;
}

export interface StoryInteractionsResponse {
  data: StoryInteractionItem[];
  meta: {
    code: number;
  };
}
